module.exports = __webpack_public_path__ + "static/img/68-1.d42aa90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/68-1.jpg
// module id = 2QnF
// module chunks = 0